import React from "react";

const PotassiumCarbonateAnhydrous = () => {
  return (
    <div>
      <div className="other-info-section-main">
        <div className="container">
          <div className="other-info-section" id="productInfo">
            <div
              className="product-description-section-main"
              id="productDescription"
            >
              <div className="product-description-section">
                <h2>Product Description</h2>
                <p style={{ marginBottom: "0in" }}>
                  <strong>Product Details :</strong>
                </p>
                <table cellPadding={4} cellSpacing={0} width="100%">
                  <colgroup>
                    <col width="128*" />
                    <col width="128*" />
                  </colgroup>
                  <tbody>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "1px medium 1px 1px",
                          borderStyle: "solid none solid solid",
                          borderColor:
                            "rgb(0, 0, 0) currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0.04in 0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>Product Name</p>
                      </td>
                      <td
                        style={{
                          border: "1px solid rgb(0, 0, 0)",
                          padding: "0.04in",
                        }}
                        width="50%"
                      >
                        <p>: POTASSIUM CARBONATE ANHYDROUS</p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>C.A.S. No.</p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>: 584-08-7</p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>Molecular Formula</p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>
                          : K<sub>2</sub>CO<sub>3</sub>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>Molecular Weight</p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="50%"
                      >
                        <p>: 138.21 g/mol</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p lang="en" style={{ marginBottom: "0in" }}>
                  <br />
                </p>
                <table cellPadding={4} cellSpacing={0} width="100%">
                  <colgroup>
                    <col width="85*" />
                    <col width="85*" />
                    <col width="85*" />
                  </colgroup>
                  <tbody>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "1px medium 1px 1px",
                          borderStyle: "solid none solid solid",
                          borderColor:
                            "rgb(0, 0, 0) currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0.04in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">SPECIFICATION</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "1px medium 1px 1px",
                          borderStyle: "solid none solid solid",
                          borderColor:
                            "rgb(0, 0, 0) currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0.04in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">BP</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          border: "1px solid rgb(0, 0, 0)",
                          padding: "0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">USP</span>
                          </strong>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Description</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">
                            White or almost white granular Powder hygroscopic.
                          </span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">
                            White or almost white granular Powder hygroscopic.
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Solubility</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">
                            Freely Soluble in water, practically insoluble in
                            Ethanol (96%)
                          </span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p style={{ marginBottom: "0in" }}>
                          <strong>
                            <span lang="en">Identification</span>
                          </strong>
                        </p>
                        <p style={{ marginBottom: "0in" }}>&nbsp;</p>
                        <ul>
                          <li>
                            <strong>
                              <span lang="en">Reaction</span>
                            </strong>
                          </li>
                          <li>
                            <strong>
                              <span lang="en">Reaction</span>
                            </strong>
                          </li>
                          <li>
                            <strong>
                              <span lang="en">Reaction</span>
                            </strong>
                          </li>
                        </ul>
                        <p>&nbsp;</p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p style={{ marginBottom: "0in" }}>
                          <span lang="en">
                            <br />
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span lang="en">
                              A : The solution is strongly alkaline
                            </span>
                          </li>
                          <li>
                            <span lang="en">
                              B: Test A gives the reaction of Carbonates &amp;
                              Bicarbonates.
                            </span>
                          </li>
                          <li>
                            <span lang="en">
                              C: Test A gives reaction of Potassium.
                            </span>
                          </li>
                        </ul>
                        <p>&nbsp;</p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p style={{ marginBottom: "0in" }}>
                          <span lang="en">
                            <br />
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span lang="en">
                              A: Test A gives the reaction of Carbonates.
                            </span>
                          </li>
                          <li>
                            <span lang="en">
                              B: Test A gives reaction of Potassium.
                            </span>
                          </li>
                        </ul>
                        <p>&nbsp;</p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Insoluble substances</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">
                            The solution is complete, clear &amp; Colorless.
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Heavy metals</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p lang="en">
                          <br />
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 5 ppm</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Calcium</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 100 ppm</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Iron</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 10 ppm</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Chlorides</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 100 ppm</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Loss on Drying</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 5.0 %</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 0.5 %</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Sulphates</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">NMT 100 ppm</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Organic Volatile Impurities</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">Meets the requirement</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Residual Solvents</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">-</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">Meets the requirement</span>
                        </p>
                      </td>
                    </tr>
                    <tr valign="top">
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <strong>
                            <span lang="en">Assay</span>
                          </strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium medium 1px 1px",
                          borderStyle: "none none solid solid",
                          borderColor:
                            "currentcolor currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">99.0 % - 101 % (on dry basis)</span>
                        </p>
                      </td>
                      <td
                        style={{
                          borderWidth: "medium 1px 1px",
                          borderStyle: "none solid solid",
                          borderColor: "currentcolor rgb(0, 0, 0) rgb(0, 0, 0)",
                          padding: "0in 0.04in 0.04in",
                        }}
                        width="33%"
                      >
                        <p>
                          <span lang="en">99.5 % - 100.5 %</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PotassiumCarbonateAnhydrous;
